import { useState } from 'react';

export const useImagesWithDifferentRatios = () => {
  const [openRatiosDialog, setOpenRatiosDialog] = useState<{ show: boolean; url: string | null }>({
    show: false,
    url: null
  });

  const handleCloseRatiosDialog = () => {
    setOpenRatiosDialog({ show: false, url: null });
  };

  const handleOpenRatiosDialog = (url: string) => {
    setOpenRatiosDialog({ show: true, url });
  };

  return { openRatiosDialog, handleOpenRatiosDialog, handleCloseRatiosDialog };
};
